import {Button, Container, Stack} from "@mui/material";
import pleshDark from "../../../../theme/pleshDark";
import React from "react";
import DOMPurify from 'dompurify';
import './TextQuestion.css'

const TextQuestion = ({textContent}) => {
    return (
        <Container maxWidth={'md'} mt={3} alignItems={'start'} spacing={2} px={3} sx={{color:'#000'}}>
            <RichTextViewer content={textContent}/>
        </Container>
    )
}

export default TextQuestion

const RichTextViewer = ({ content }) => {
    const cleanHTML = DOMPurify.sanitize(content);
    return <div id={"textQuestion"} dangerouslySetInnerHTML={{ __html: content }} />;
};